module.exports = __webpack_public_path__ + "assets/img/2022_03.5c607645.png";